import Header40 from './Header40'
export default Header40
